module.exports = __webpack_public_path__ + "img/AG.7a5c6f51.svg";